<template>
  <Component
    :is="to ? HyperLink : 'div'"
    v-bind="{ to }"
    :class="['my-orders-card', { 'my-orders-card--link': to }]"
    :tabindex="to ? -1 : 0"
  >
    <LcCard
      :model-value="initiallyExpanded"
      v-bind="{ ...$attrs, variant }"
      header-class="my-orders-card-header"
      show-separator
    >
      <template #header>
        <div>
          <slot name="header" />
        </div>

        <div v-if="$slots['header-end']" class="meta flex align-center">
          <slot name="header-end" />
        </div>
      </template>

      <section>
        <IconList>
          <slot name="list" />
        </IconList>
      </section>

      <slot />

      <template v-if="$slots.cta" #footer>
        <div class="flex justify-between items-center pt-050">
          <div>
            <slot name="replay-button" />
          </div>
          <LcButton
            class="h-400 -mr-150"
            icon="arrow-right"
            icon-position="right"
            no-padding
            size="small"
            variant="tertiary"
          >
            <slot name="cta" />
          </LcButton>
        </div>
      </template>
    </LcCard>
  </Component>
</template>

<script lang="ts" setup>
import type { RouteLocationRaw } from 'vue-router'

import { HyperLink } from '#components'

type MyOrdersCardProps = {
  initiallyExpanded?: boolean
  to?: RouteLocationRaw
  variant?: 'default' | 'order'
}

const { initiallyExpanded = false, variant = 'order' } = defineProps<MyOrdersCardProps>()
</script>

<style lang="scss" scoped>
.my-orders-card {
  :deep(.my-orders-card-header) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .meta {
      cursor: auto;
    }
  }

  /* stylelint-disable-next-line selector-class-pattern */
  :deep(.lc-card--expandable) .my-orders-card-header {
    min-height: token('size/600');
    padding-block: token('size/space/gap/100');
  }

  &--link :deep(.my-orders-card-header) .meta {
    cursor: pointer;
  }
}
</style>
